module.exports = __webpack_public_path__ + "media/images/riders/small/JORDAN_SARROU-9e2fdb4a2cf1e5260158a60b20d63d0b.png";